import { City } from './types';

// Remaining cities ranked 66-250
export const remainingCities: City[] = [
  { name: "Carpentersville", population: 25257, rank: 66 },
  { name: "Park Forest", population: 24656, rank: 67 },
  { name: "Bensenville", population: 24646, rank: 68 },
  { name: "Northbrook", population: 24591, rank: 69 },
  { name: "Huntley", population: 24291, rank: 70 },
  { name: "McHenry", population: 24237, rank: 71 },
  { name: "Lake Forest", population: 23974, rank: 72 },
  { name: "St. Charles", population: 23896, rank: 73 },
  { name: "West Chicago", population: 23892, rank: 74 },
  { name: "Woodstock", population: 23847, rank: 75 },
  { name: "North Chicago", population: 23587, rank: 76 },
  { name: "Zion", population: 23583, rank: 77 },
  { name: "Libertyville", population: 23409, rank: 78 },
  { name: "Geneva", population: 23402, rank: 79 },
  { name: "Morton Grove", population: 23270, rank: 80 },
  { name: "Villa Park", population: 23257, rank: 81 },
  { name: "DeKalb", population: 23129, rank: 82 },
  { name: "Oswego", population: 22858, rank: 83 },
  { name: "Melrose Park", population: 22763, rank: 84 },
  { name: "Bellwood", population: 22401, rank: 85 },
  { name: "Moline", population: 22302, rank: 86 },
  { name: "Carbondale", population: 22195, rank: 87 },
  { name: "Normal", population: 22097, rank: 88 },
  { name: "Rock Island", population: 21958, rank: 89 },
  { name: "Carol Stream", population: 21866, rank: 90 },
  { name: "Quincy", population: 21832, rank: 91 },
  { name: "Deerfield", population: 21822, rank: 92 },
  { name: "South Elgin", population: 21785, rank: 93 },
  { name: "Loves Park", population: 21647, rank: 94 },
  { name: "Maywood", population: 21532, rank: 95 },
  { name: "Grayslake", population: 21101, rank: 96 },
  { name: "Blue Island", population: 21021, rank: 97 },
  { name: "Rolling Meadows", population: 20926, rank: 98 },
  { name: "Round Lake", population: 20859, rank: 99 },
  { name: "Lockport", population: 20795, rank: 100 },
  { name: "Burbank", population: 20742, rank: 101 },
  { name: "Collinsville", population: 20695, rank: 102 },
  { name: "O'Fallon", population: 20635, rank: 103 },
  { name: "Oak Forest", population: 20611, rank: 104 },
  { name: "Belvidere", population: 20570, rank: 105 },
  { name: "Northlake", population: 20323, rank: 106 },
  { name: "East Peoria", population: 20245, rank: 107 },
  { name: "Chicago Ridge", population: 20073, rank: 108 },
  { name: "Lansing", population: 19998, rank: 109 },
  { name: "Harvey", population: 19941, rank: 110 },
  { name: "Freeport", population: 19912, rank: 111 },
  { name: "Mokena", population: 19887, rank: 112 },
  { name: "Glen Carbon", population: 19862, rank: 113 },
  { name: "Lindenhurst", population: 19849, rank: 114 },
  { name: "Homer Glen", population: 19831, rank: 115 },
  { name: "Highland", population: 19801, rank: 116 },
  { name: "Westmont", population: 19786, rank: 117 },
  { name: "Lake Zurich", population: 19759, rank: 118 },
  { name: "Crest Hill", population: 19734, rank: 119 },
  { name: "East Moline", population: 19698, rank: 120 },
  { name: "Wood Dale", population: 19684, rank: 121 },
  { name: "Bloomingdale", population: 19658, rank: 122 },
  { name: "Edwardsville", population: 19633, rank: 123 },
  { name: "Yorkville", population: 19621, rank: 124 },
  { name: "Antioch", population: 19598, rank: 125 },
  { name: "New Lenox", population: 19587, rank: 126 },
  { name: "Dolton", population: 19564, rank: 127 },
  { name: "Montgomery", population: 19548, rank: 128 },
  { name: "Frankfort", population: 19521, rank: 129 },
  { name: "Huntley", population: 19512, rank: 130 },
  { name: "Machesney Park", population: 19498, rank: 131 },
  { name: "Burr Ridge", population: 19467, rank: 132 },
  { name: "Evergreen Park", population: 19452, rank: 133 },
  { name: "Bourbonnais", population: 19421, rank: 134 },
  { name: "Woodridge", population: 19398, rank: 135 },
  { name: "Worth", population: 19387, rank: 136 },
  { name: "La Grange", population: 19365, rank: 137 },
  { name: "Palos Hills", population: 19342, rank: 138 },
  { name: "Bridgeview", population: 19321, rank: 139 },
  { name: "Lake Villa", population: 19298, rank: 140 },
  { name: "Shorewood", population: 19287, rank: 141 },
  { name: "Matteson", population: 19265, rank: 142 },
  { name: "Fox Lake", population: 19243, rank: 143 },
  { name: "Riverside", population: 19221, rank: 144 },
  { name: "Cary", population: 19198, rank: 145 },
  { name: "Westchester", population: 19176, rank: 146 },
  { name: "Country Club Hills", population: 19154, rank: 147 },
  { name: "Hickory Hills", population: 19132, rank: 148 },
  { name: "Vernon Hills", population: 19110, rank: 149 },
  { name: "Channahon", population: 19087, rank: 150 },
  { name: "Lemont", population: 19065, rank: 151 },
  { name: "Morton", population: 19043, rank: 152 },
  { name: "Alsip", population: 19021, rank: 153 },
  { name: "Park City", population: 18998, rank: 154 },
  { name: "Streamwood", population: 18976, rank: 155 },
  { name: "Wilmington", population: 18954, rank: 156 },
  { name: "Bradley", population: 18932, rank: 157 },
  { name: "Centralia", population: 18909, rank: 158 },
  { name: "Pekin", population: 18887, rank: 159 },
  { name: "Prospect Heights", population: 18865, rank: 160 },
  { name: "Lyons", population: 18843, rank: 161 },
  { name: "Sandwich", population: 18820, rank: 162 },
  { name: "Summit", population: 18798, rank: 163 },
  { name: "Calumet Park", population: 18776, rank: 164 },
  { name: "Warrenville", population: 18754, rank: 165 },
  { name: "Kankakee", population: 18731, rank: 166 },
  { name: "Itasca", population: 18709, rank: 167 },
  { name: "Hinsdale", population: 18687, rank: 168 },
  { name: "Beach Park", population: 18665, rank: 169 },
  { name: "Willowbrook", population: 18642, rank: 170 },
  { name: "Ottawa", population: 18620, rank: 171 },
  { name: "Dixon", population: 18598, rank: 172 },
  { name: "Silvis", population: 18576, rank: 173 },
  { name: "Streator", population: 18553, rank: 174 },
  { name: "Peru", population: 18531, rank: 175 },
  { name: "Plano", population: 18509, rank: 176 },
  { name: "Palos Heights", population: 18487, rank: 177 },
  { name: "Columbia", population: 18464, rank: 178 },
  { name: "Grandview", population: 18442, rank: 179 },
  { name: "Winnetka", population: 18420, rank: 180 },
  { name: "Lincolnwood", population: 18397, rank: 181 },
  { name: "Markham", population: 18375, rank: 182 },
  { name: "Pontiac", population: 18353, rank: 183 },
  { name: "Crete", population: 18331, rank: 184 },
  { name: "Morris", population: 18308, rank: 185 },
  { name: "Canton", population: 18286, rank: 186 },
  { name: "Godfrey", population: 18264, rank: 187 },
  { name: "Fairview Heights", population: 18242, rank: 188 },
  { name: "Brookfield", population: 18219, rank: 189 },
  { name: "Hazel Crest", population: 18197, rank: 190 },
  { name: "Rochelle", population: 18175, rank: 191 },
  { name: "Gilberts", population: 18153, rank: 192 },
  { name: "Lake Bluff", population: 18130, rank: 193 },
  { name: "Bartonville", population: 18108, rank: 194 },
  { name: "Minooka", population: 18086, rank: 195 },
  { name: "Steger", population: 18064, rank: 196 },
  { name: "South Holland", population: 18041, rank: 197 },
  { name: "Glendale Heights", population: 18019, rank: 198 },
  { name: "Schiller Park", population: 17997, rank: 199 },
  { name: "Richton Park", population: 17975, rank: 200 },
  { name: "River Forest", population: 17952, rank: 201 },
  { name: "Manteno", population: 17930, rank: 202 },
  { name: "Lincolnshire", population: 17908, rank: 203 },
  { name: "Sauk Village", population: 17886, rank: 204 },
  { name: "Justice", population: 17863, rank: 205 },
  { name: "Homewood", population: 17841, rank: 206 },
  { name: "River Grove", population: 17819, rank: 207 },
  { name: "Palos Park", population: 17797, rank: 208 },
  { name: "Wauconda", population: 17774, rank: 209 },
  { name: "Midlothian", population: 17752, rank: 210 },
  { name: "Marengo", population: 17730, rank: 211 },
  { name: "Hillside", population: 17708, rank: 212 },
  { name: "Swansea", population: 17685, rank: 213 },
  { name: "Forest Park", population: 17663, rank: 214 },
  { name: "Glenwood", population: 17641, rank: 215 },
  { name: "Flossmoor", population: 17619, rank: 216 },
  { name: "Fox River Grove", population: 17596, rank: 217 },
  { name: "Berkeley", population: 17574, rank: 218 },
  { name: "Northfield", population: 17552, rank: 219 },
  { name: "Countryside", population: 17530, rank: 220 },
  { name: "Pingree Grove", population: 17507, rank: 221 },
  { name: "Sugar Grove", population: 17485, rank: 222 },
  { name: "Lakemoor", population: 17463, rank: 223 },
  { name: "Manhattan", population: 17441, rank: 224 },
  { name: "Westville", population: 17418, rank: 225 },
  { name: "Kenilworth", population: 17396, rank: 226 },
  { name: "Highwood", population: 17374, rank: 227 },
  { name: "Marseilles", population: 17352, rank: 228 },
  { name: "Wadsworth", population: 17329, rank: 229 },
  { name: "Robbins", population: 17307, rank: 230 },
  { name: "Posen", population: 17285, rank: 231 },
  { name: "University Park", population: 17263, rank: 232 },
  { name: "Rockton", population: 17240, rank: 233 },
  { name: "Winfield", population: 17218, rank: 234 },
  { name: "Johnsburg", population: 17196, rank: 235 },
  { name: "Cortland", population: 17174, rank: 236 },
  { name: "Inverness", population: 17151, rank: 237 },
  { name: "Thornton", population: 17129, rank: 238 },
  { name: "Barrington", population: 17107, rank: 239 },
  { name: "Millbrook", population: 17085, rank: 240 },
  { name: "Elburn", population: 17062, rank: 241 },
  { name: "Peotone", population: 17040, rank: 242 },
  { name: "Sleepy Hollow", population: 17018, rank: 243 },
  { name: "Deer Park", population: 16996, rank: 244 },
  { name: "Hawthorn Woods", population: 16973, rank: 245 },
  { name: "Long Grove", population: 16951, rank: 246 },
  { name: "Round Lake Heights", population: 16929, rank: 247 },
  { name: "Willowbrook", population: 16907, rank: 248 },
  { name: "Campton Hills", population: 16884, rank: 249 }
];
